import React, { useContext, useEffect, useState } from "react";
import { InputSearch } from "@components/inputSearch";
import { Context } from "@components/useContext/context";
import ImageContainer from "@components/imageContainer";
import FilterChips from "@components/filterChips";
import {
  Wrapper,
  CardsContainer,
  CardWrapper,
  CardLabel,
  ArrowIconWrapper,
  VariantMessage
} from "./styles";
import UnableToFindBrandCard from "@components/unableToFindCard";
import ArrowSvg from "@public/images/icons/arrow.svg";
import { resolvePath } from "@utils/resolvePath";
import { executeActions, getRequestpayload, removeUnderscoreAndCapitalize } from "@utils/index";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { setPayload } from "@actions/setPayloadData";
import { useDispatch } from "react-redux";
interface CardProps {
  name: string;
  id: string;
  selectionType?: string;
  onClick?: (id: string, name: string) => void;
}

const NewCarModelFuelTypeSelection = (props: any) => {
  const {
    selection_type,
    selection_list,
    variantListByTransmissionType,
    variantList,
    fuel_type_list,
    show_Search_Button,
    show_Filter_Chips,
    actions,
    unableToFindBrandCard
  } = props;
  const { on_click, on_unable_to_find_card_click,searchCallback } = actions || [];
  const { isDesktop } = useContext(Context);
  const [input, setInput] = useState<string>("");
  const [query, setQuery] = useState<string>("");
  const [selectionList, setSelectionList] = useState<any[]>([]);
  const [filterChips, setFilterChips] = useState<any[]>([]);
  const [searchInputPlaceholder, setSearchInputPlaceholder] = useState<string>(
    "Search your car's model"
  );
  const [displayedSelectionList, setDisplayedSelectionList] = useState<any[]>(
    []
  );
  useEffect(() => {
    if (selection_type === "model") {
      const itemList = selection_list.map((item) => ({
        id: item.model_id,
        name: item.model_name
      }));
      setSelectionList(itemList);
      setDisplayedSelectionList(itemList);
    } else if (selection_type === "fuel_type") {
      setDisplayedSelectionList(
        fuel_type_list?.map((item) => ({
          id: item || "",
          name:
            item === "internal_lpg_cng"
              ? "LPG/CNG"
              : removeUnderscoreAndCapitalize(item) || ""
        }))
      );
    } else if (selection_type === "variant") {
      const filterChipsList = !!variantListByTransmissionType
        ? Object.keys(variantListByTransmissionType)
        : [];

      if (filterChipsList.length === 1) {
        setFilterChips(
          filterChipsList.map((item) => ({
            id: item,
            label: item,
            selected: true
          }))
        );
        setDisplayedSelectionList(
          variantListByTransmissionType[filterChipsList[0]].map((item) => ({
            id: item?.variant_ekey || "",
            name: item?.variant_name || ""
          }))
        );
      } else {
        setFilterChips(
          filterChipsList.map((item) => ({
            id: item,
            label: item,
            selected: false
          }))
        );
      }
    }
  }, [props]);

  const searchSelectionList = (input: string) => {
    return selectionList.filter((item: any) =>
      item.name.toLowerCase().includes(input.toLowerCase())
    );
  };

  const handleChipClick = (chipId: string) => {
    const { data, journey } = getRequestpayload();
    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "tap_btn_transmission_type_selected",
        action_type: "tap_btn",
        transmission_type:filterChips.find((item) => item.id === chipId)?.label
      },
      odata: {
        journey
      },
      event_name: "action"
    });
    setDisplayedSelectionList(
      variantListByTransmissionType[chipId].map((item) => ({
        id: item?.variant_ekey || "",
        name: item?.variant_name || ""
      }))
    );
    setFilterChips(
      Object.keys(variantListByTransmissionType).map((item) => ({
        id: item,
        label: item,
        selected: item === chipId
      }))
    );
  };

  const handleCardClick = (id: string, name: string) => {
    if(selection_type === "variant") {
      setPayload({
        payloadData: {
          variant_ekey: id
        }
      });
    }

    (on_click || []).forEach((action) => {
      if (typeof action.funCall === "function") {
        action.funCall({
          data: {
            [selection_type === "model"
              ? "model_id"
              : selection_type === "fuel_type"
                ? "fuel_type"
                : selection_type === "variant"
                  ? "variant_ekey"
                  : "id"]: id,
            [selection_type === "model"
              ? "model"
              : selection_type === "fuel_type"
                ? "fuel_type_name"
                : selection_type === "variant"
                  ? "variant"
                  : "name"]: name
          },
          ...action.args
        });
      }
    });
  };
  const onSearchCallback = () => {
    executeActions(searchCallback);
  };
  useEffect(() => {
    if (input.length > 0) {
      setDisplayedSelectionList(searchSelectionList(input));
    } else {
      selectionList.length > 0 && setDisplayedSelectionList(selectionList);
    }
  }, [input]);
  return (
    <Wrapper>
      {show_Search_Button && (
        <InputSearch
          isDesktop={isDesktop}
          placeholder={searchInputPlaceholder}
          searchInput={input}
          setSearchInput={setInput}
          query={query}
          searchCallback={onSearchCallback}
        />
      )}
      {show_Filter_Chips && (
        <FilterChips chips={filterChips} onChipClick={handleChipClick} />
      )}
      <CardsContainer
        style={
          selection_type === "fuel_type"
            ? { margin: "0" }
            : { margin: "16px 0" }
        }
      >
        {displayedSelectionList?.length > 0 &&
          displayedSelectionList?.map((item, index) => (
            <Card
              key={item.id || index}
              name={item.name}
              id={item.id}
              selectionType={selection_type}
              onClick={handleCardClick}
            />
          ))}
      </CardsContainer>
      {displayedSelectionList.length === 0 && selection_type === "model" && (
        <UnableToFindBrandCard
          imgSrc={unableToFindBrandCard.imgSrc}
          alt={unableToFindBrandCard.alt}
          height={unableToFindBrandCard.height}
          width={unableToFindBrandCard.width}
          title={unableToFindBrandCard.title}
          buttonLabel={unableToFindBrandCard.buttonLabel}
          isFullWidth={unableToFindBrandCard.isFullWidth}
          onClick={() => {
            executeActions(on_unable_to_find_card_click);
          }}
        />
      )}
      {displayedSelectionList.length === 0 && selection_type === "variant" && (
        <>
          <ArrowIconWrapper>
            <ArrowSvg />
          </ArrowIconWrapper>
          <VariantMessage>Select type to see variants</VariantMessage>
        </>
      )}
    </Wrapper>
  );
};

export const Card = ({ name, id, selectionType, onClick }: CardProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick(id, name);
    }
  };

  return (
    <CardWrapper onClick={handleClick}>
      <CardLabel>{name}</CardLabel>
      <ImageContainer
        imgSrc={resolvePath("/images/Chevron_right.svg")}
        alt="chevron_right"
        height={20}
        width={20}
      />
    </CardWrapper>
  );
};

export default NewCarModelFuelTypeSelection;
